import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getFormattedNumberWithCurrency } from '@skytech/utils'

import { useProfile } from './user'

export const useFormattedNumberWithCurrency = () => {
  const profile = useProfile()

  const formatNumber = ({
    amount,
    currency,
    locale,
    precision,
  }: {
    amount: number
    currency?: Intl.NumberFormatOptions['currency'] | null
    locale?: Locale
    precision?: number
  }) =>
    getFormattedNumberWithCurrency({
      amount,
      precision,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
      currency: currency || profile?.currency,
    })

  return { formatNumber }
}
